import script from "./BidFormEnglish.vue?vue&type=script&setup=true&lang=ts"
export * from "./BidFormEnglish.vue?vue&type=script&setup=true&lang=ts"

import "./BidFormEnglish.vue?vue&type=style&index=0&id=764f94ca&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-764f94ca"]])

export default __exports__